/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { FaqModel } from './FaqModel';
import { FaqModels } from './faqModels';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class FaqService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allFaq(applicationid,devicetype,version): Promise<any> {
        var data = {
            applicationid : applicationid,
            devicetype : devicetype,
            version : version
        }
        return this.httpmanagerService.HttpPost('sfaq/allfaq', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    inFaq(data): Promise<any> {
        return this.httpmanagerService.HttpPost('sfaq/create', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    uFaq(id, data): Promise<FaqModels> {
        return this.httpmanagerService.HttpPut('sfaq', JSON.stringify(data), id).then(data => {
            return data;
        })
    }
    dFaq(id): Promise<FaqModels> {
        return this.httpmanagerService.HttpDelete('sfaq', id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/faq/faq.service.ts